(function () {

function $c1dca996b1c00bfe$export$92dae54fac3dcf77(root = document) {
    const vendor = window.fbsThemeVendors || {};
    const Swiper = vendor.Swiper;
    const modules = vendor.SwiperModules || {};
    if (!Swiper || !modules.Navigation || !modules.Pagination || !modules.Keyboard || !modules.A11y) return;
    root.querySelectorAll('[data-testimonials-carousel]').forEach((carousel)=>{
        if (carousel.swiperInstance) return;
        const viewport = carousel.querySelector('.fbs-testimonials-section__viewport');
        const controls = carousel.querySelector('.fbs-testimonials-section__controls');
        if (!viewport || !controls) return;
        const prev = controls.querySelector('[data-testimonials-prev]');
        const next = controls.querySelector('[data-testimonials-next]');
        const pagination = controls.querySelector('[data-testimonials-dots]');
        if (!prev || !next || !pagination) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const swiper = new Swiper(viewport, {
            modules: [
                modules.Navigation,
                modules.Pagination,
                modules.Keyboard,
                modules.A11y
            ],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: reducedMotion.matches ? 0 : 450,
            grabCursor: true,
            allowTouchMove: true,
            simulateTouch: true,
            watchOverflow: true,
            resistanceRatio: 0.65,
            rewind: false,
            loop: false,
            autoHeight: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            a11y: {
                enabled: true
            },
            navigation: {
                prevEl: prev,
                nextEl: next,
                disabledClass: 'swiper-button-disabled'
            },
            pagination: {
                el: pagination,
                clickable: true,
                bulletClass: 'fbs-testimonials-section__dot',
                bulletActiveClass: 'fbs-testimonials-section__dot--active',
                renderBullet (index, className) {
                    return '<button type="button" class="' + className + '" aria-label="Go to testimonial ' + (index + 1) + '"></button>';
                }
            },
            breakpoints: {
                700: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1100: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },
            on: {
                init (instance) {
                    controls.hidden = instance.isLocked;
                },
                lock () {
                    controls.hidden = true;
                },
                unlock () {
                    controls.hidden = false;
                }
            }
        });
        carousel.swiperInstance = swiper;
        const syncMotion = ()=>{
            swiper.params.speed = reducedMotion.matches ? 0 : 450;
        };
        if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', syncMotion);
        else if (reducedMotion.addListener) reducedMotion.addListener(syncMotion);
    });
}


const $076e6a0926f2df2d$var$runBlock = ()=>(0, $c1dca996b1c00bfe$export$92dae54fac3dcf77)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $076e6a0926f2df2d$var$runBlock, {
    once: true
});
else $076e6a0926f2df2d$var$runBlock();

})();
//# sourceMappingURL=testimonials-section.js.map
